import React, { useEffect, useRef } from "react";

import { GlobalWorkerOptions, getDocument } from "pdfjs-dist/build/pdf";
import "pdfjs-dist/build/pdf.worker.entry";

GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

const CustomPdfViewer = ({ path }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const response = await fetch(path);
      const buffer = await response.arrayBuffer();

      const pdf = await getDocument({
        data: buffer,
        disableRange: true,
        disableStream: true,
        disableAutoFetch: true
      }).promise;

      const totalPages = pdf.numPages;

      containerRef.current.innerHTML = "";

      for (let pageNo = 1; pageNo <= totalPages; pageNo++) {
        if (cancelled) return;

        const page = await pdf.getPage(pageNo);
        const viewport = page.getViewport({ scale: 1 });

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        containerRef.current.appendChild(canvas);

        await page.render({ canvasContext: ctx, viewport }).promise;

        const gap = document.createElement("div");
        gap.style.height = "20px";
        containerRef.current.appendChild(gap);
      }
    })();

    return () => { cancelled = true; };
  }, [path]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        paddingBottom: "20px"
      }}
    />
  );
};

export default CustomPdfViewer;